import { FormRadio, FormCheckbox } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { Field } from 'redux-form'
import { Form, Header } from 'semantic-ui-react'

export default class ProductStatus extends React.Component {
  render() {
    const { archived } = this.props
    return (
      <div>
        <Header
          as="h3"
          content={I18n.t(archived ? 'admin.product.status.status_was_archived' : 'admin.product.status.status')}
          className={archived && "changed"}
          dividing
        />
        <Form.Group>
          <Field
            component={FormRadio}
            label={I18n.t('admin.product.status.active')}
            name="status"
            option="active"
          />
          <Field
            component={FormRadio}
            label={I18n.t('admin.product.status.inactive')}
            name="status"
            option="inactive"
          />
          <Field
            component={FormRadio}
            label={I18n.t('admin.product.status.archived')}
            name="status"
            option="archived"
            className={config.semantic_ui.primary_color}
          />
          <Field
            component={FormCheckbox}
            label={I18n.t('admin.product.status.always_on_stock')}
            name="alwaysOnStock"
          />
          <Field
            component={FormCheckbox}
            label={I18n.t('admin.product.status.clearance')}
            name="clearance"
          />
        </Form.Group>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductStatus.jsx